<mat-card class="main-card center-wrapper">
  <!-- Header della tabella -->
  <div *ngIf="header" class="table-header">
    <h3>{{ header.title }}</h3>
    <div class="button-header">
      <!-- Standard buttons -->
      <ng-container *ngFor="let button of header.buttons">
        <ng-container *ngIf="button.isMenu && button.showCondition()">
          <app-menu-button
            [label]="button.label"
            [menuItems]="button.menuItems"
          ></app-menu-button>
        </ng-container>
        <ng-container *ngIf="!button.isMenu">
          <button
            *ngIf="button.showCondition()"
            mat-flat-button
            color="primary"
            (click)="button.action()"
          >
            {{ button.label }}
          </button>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="mat-elevation-z8">
    <table
      *ngIf="displayedColumns"
      mat-table
      [dataSource]="dataSource"
      class="table fixed-layout"
      matSort
    >
      <!-- Definizione delle colonne in maniera dinamica -->
      <ng-container>
        <ng-container
          *ngFor="let entry of displayedColumns | keyvalue"
          [matColumnDef]="entry.key"
        >
          <ng-container *ngIf="enableSorting; else noSortHeader">
            <th
              mat-header-cell
              *matHeaderCellDef
              [mat-sort-header]="entry.key"
              [style.width]="getColumnWidth(entry.key)"
              [innerHTML]="getSafeHtml(entry.value)"
              disableClear
            ></th>
          </ng-container>
          <ng-template #noSortHeader>
            <th
              mat-header-cell
              *matHeaderCellDef
              [style.width]="getColumnWidth(entry.key)"
              [innerHTML]="getSafeHtml(entry.value)"
            ></th>
          </ng-template>
          <td
            mat-cell
            *matCellDef="let element"
            [style.width]="getColumnWidth(entry.key)"
          >
            <!-- FIXME -->
            <ng-container *ngIf="entry.key === 'sender'; else genericCell">
              <span
                class="clickable-sender"
                [ngClass]="{
                  'selected-sender': element.sender === selectedSender
                }"
                style="cursor: pointer; text-decoration: underline"
                (click)="senderClick.emit(element.sender)"
                matTooltip="Visualizza chat completa"
                matTooltipPosition="above"
                [innerHTML]="getSafeHtml(element.sender)"
              >
              </span>
            </ng-container>
            <ng-template #genericCell>
              <ng-container
                *ngIf="tooltipColumns.includes(entry.key); else noEllipsis"
              >
                <div class="flex-row-center g-4">
                  <button
                    mat-icon-button
                    class="small-icon-button"
                    aria-label="Mostra dettaglio"
                    [matTooltip]="element[entry.key]"
                    #tooltip="matTooltip"
                    matTooltipShowDelay="0"
                    matTooltipHideDelay="0"
                    [matTooltipPosition]="'above'"
                    (mouseenter)="$event.stopImmediatePropagation()"
                    (mouseleave)="$event.stopImmediatePropagation()"
                    (click)="tooltip.toggle()"
                  >
                    <mat-icon>info_outline</mat-icon>
                  </button>
                  <span
                    class="ellipsis"
                    [style.max-width]="ellipsisMaxWidth"
                    [innerHTML]="getSafeHtml(element[entry.key])"
                  >
                  </span>
                  <!-- {{ element[entry.key] }} -->
                </div>
              </ng-container>
              <ng-template #noEllipsis>
                <span [innerHTML]="getSafeHtml(element[entry.key])"></span>
              </ng-template>
            </ng-template>
          </td>
        </ng-container>

        <!-- Colonna statica per le azioni, gestisce un'array di azioni -->
        <ng-container
          *ngIf="actions && actions.length > 0"
          matColumnDef="actions"
        >
          <th mat-header-cell *matHeaderCellDef>Azioni</th>
          <td mat-cell *matCellDef="let element">
            <div class="actions">
              <ng-container *ngFor="let action of actions">
                <button
                  class="flat"
                  mat-icon-button
                  *ngIf="action.showCondition(element)"
                  (click)="action.action(element)"
                  matTooltip="{{ action.label ? action.label : action?.dynamicLabel(element) }}"
                >
                  <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
                </button>
              </ng-container>
            </div>
          </td>
        </ng-container>

        <!-- Riga per gli header -->
        <tr mat-header-row *matHeaderRowDef="allColumns"></tr>

        <!-- Riga dei dati -->
        <tr mat-row *matRowDef="let row; columns: allColumns"></tr>
      </ng-container>
    </table>
  </div>
  <div *ngIf="!data || data.length === 0" class="mt-2 text-center">
    Non ci sono elementi da visualizzare
  </div>

  <mat-paginator
    class="bg-unset mt-2"
    *ngIf="pageSize > 0"
    [length]="totalElements ?? data.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="[pageSize, pageSize * 2, pageSize * 4]"
    aria-label="Selettore pagina"
    showFirstLastButtons
  >
  </mat-paginator>
</mat-card>
